export function translateValues(json) {
  return json.map(row => {
    const object = {};
    for (let [key, value] of Object.entries(row)) {
      if (value) {
        if (value === "Nej") value = false;
        if (value === "Ja") value = true;
        object[key] = value;
      }
      if (key === 'InStock')
        object[key] = 0
    }
    return object;
  })
}



export function mergeRows(rows) {
  const orderedEntries = {};
  rows.forEach(oldRow => {
    const { UOM, UOMNavn, Unit } = oldRow;
    const Price = Number(oldRow.Price.replace(",", "."));
    const PriceQuantity = Number(oldRow.PriceQuantity.replace(",", "."));
    const row = Object.assign({}, oldRow)
    delete row.Price;
    delete row.PriceQuantity;
    const id = row.ItemNumber;
    orderedEntries[id] = orderedEntries[id] || row;
    orderedEntries[id].Price = orderedEntries[id].Price || [];
    orderedEntries[id].Price.push({ PriceQuantity, Price, UOM, UOMNavn, Unit });
  });
  return Object.values(orderedEntries);
}